module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"contents":{"webcasts":{"meta_tags":{"description":"Experience success stories, understand complex issues, experience events up close - Discover the CAPinside webinars","title":"Past webinars"},"teaser":"You missed a webinar? No problem. Find all recordings of our online events here.","title":"Past webinars"}}}}}}')
  delete Component.options._Ctor
}
